"use client";

import { colors } from "@/components/builder/sidebars/right/Theme";
import { fixedTableTemplates } from "@/lib/server/constant";
import { TResume } from "@/lib/store/resume";
import { useEffect } from "react";

const Init = ({ resume }: { resume: TResume }) => {
  const settings = resume.data.settings;
  const isFixedJISTemaplete = fixedTableTemplates.includes(
    settings?.template || "",
  );
  const size = isFixedJISTemaplete ? 13.35 : settings?.typography.font.size;
  const magin = isFixedJISTemaplete ? 13 : settings?.page.margin;
  const lineHeight = isFixedJISTemaplete
    ? 1.65
    : settings?.typography?.lineHeight;

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--resume-font-size",
      `${(size || 16) / 16}rem`,
    );
    document.documentElement.style.setProperty(
      "--resume-line-height",
      `${lineHeight}`,
    );

    document.documentElement.style.setProperty("--margin", `${magin}px`);
    document.documentElement.style.setProperty(
      "--color-primary",
      settings?.theme.primary || colors[0],
    );
  }, [size, lineHeight, magin, settings]);

  useEffect(() => {
    if (settings?.typography.hideIcons) {
      document.querySelector("#resume-main")!?.classList.add("hide-icons");
    } else {
      document.querySelector("#resume-main")!?.classList.remove("hide-icons");
    }

    if (settings?.typography.underlineLinks) {
      document.querySelector("#resume-main")!?.classList.add("underline-links");
    } else {
      document
        .querySelector("#resume-main")!
        ?.classList.remove("underline-links");
    }
  }, [settings]);
  return <></>;
};

export default Init;
